module.exports = {
  common: {
    message: '数据错误',
    toast: '请填写完整信息'
  },
  vantText: {
    confirm: '确认',
    cancel: '取消',
  },
  MealNum: {
    title: "店名",
    lang: "选择语言",
    chooseLang: '请选择语言',
    mealNum: "人数",
    seat: '入座',
    text: '请选择人数',
    delivery: '外送'
  },
  ShopInfo: {
    title: "店铺详情",
    name: "名称",
    address: "地址",
    phone: "电话",
    time: "营业时间",
    intro: "介绍",
  },
  OrderDetail: {
    uploadVoucher: "上传凭证",
    accountInformation: "户口信息",
    title: "订单详情",
    success: '下单成功',
    pay: '已支付',
    unpaid: '未支付',
    totalNum: '总人数',
    totalPrice: "总计",
    status0: "准备中",
    status1: "制作中",
    status2: "制作完",
    status3: "已上菜",
    status4: "已送达",
    status5: "已退菜",
    time: '下单时间',
    orderNum: '订单编号',
    orderNo: '订单号码',
    back: '返回',
    containerOrder: '继续下单',
    goPay: '去支付',
    loading: '加载中...',
    cashPay: '请至柜台结账',
    subtitle: "提交订单",
    needPay: "应收金额",
    pricePay: "金额",
    toPay: "待支付",
    ticket: "订单码",
    ticketTip: '请将页面截图保存，到店显示订单码，谢谢！',
    addressMoney: '地区附加金额',
    voucherTip: "请上传凭证图片！",
    message: '数据错误',
    confirm: '确认',

    continue: "继续选择",
    submit: "下单",
    view: '查看订单',
    checkOrder: '查看订单',
    orderStatus: '订单状态',
    order0: '支付成功',
    order1: '支付失败',
    order2: '支付取消',
    returnOrder: '返回订单',
    newOrder: '重新下单',
    againOrder: '再来一单',
    noPayOrder: '订单已经超时未付款，请重新下单',
    plsPay: '请先确认已经付款',

    prompt: '请到柜台结账',
    CounterTitle: '成功',
    serviceCharge: '服务费',
    PaymentMethod: '支付方式'
  },
  Dishes: {
    title: '请选择',
    orderDetail: ' 订单详情',
    name: '菜单',
    nonefood: '暂无产品',
    myCart: '我的购物车',
    cart: '购物车',
    order: '下单',
    package: "套餐",
    del: '删除',
    isDel: '当前产品数量为1，是否移出购物车',
    addfood: '请先添加产品',
    none: '无',
    continueOrder: '继续点单',
    amounts: "合计"
  },
  PackageDetail: {
    title: "详情",
    chooseSpecs: '选份量',
    note: '口味/备注',
    remark: '备注',
    inputRemark: "请输入备注",
    certain: '确定',
    addToCart: '加入购物车',
  },
  Home: {
    shopName: '店铺名称：',
    address: '店铺地址：',
    intro: "店铺介绍：",
    phone: "店铺电话：",
    startTime: "开店时间：",
    endTime: "关门时间：",
    bookBtn: '预约',
    takeawayBtn: '点单',
    menuBtn: '菜单',
    pickup: '打包',
    packNumber: '打包号',
    p: '本服务使用便捷点餐系统',
    more: '点击了解更多',
    seat: '座位',
  },
  InputInfo: {
    infoTitle: '确认咨讯',
    required: '为必填',
    paymentVoucher: '支付凭证',
    title: "预订",
    name: '姓名',
    inputName: '输入姓名',
    phone: '手机号码',
    inputPhone: "请输入手机号码",
    maelNum: '就餐人数',
    inputMealNum: "请输入就餐人数",
    gender: "性别",
    woman: '女',
    man: '男',
    bookdate: "预订日期",
    bookMealTime: "预订时间",
    submit: '提交',
    address: '详情地址',
    inputAddress: '请输入详情地址',
    comment: '留言',
    deliveryTime: '交货时间',
    deliveryDate: '交货日期',
    PickUpDate: "取餐日期",
    PickUpTime: "取餐时间",
    inputComment: '请输入留言',
    inputDeliveryTime: "请输入交货时间",
    inputDeliveryDate: "请输入交货日期",
    inputPickUpTime: "请输入取餐时间",
    inputPickUpDate: "请输入取餐日期",
  },
  Result: {
    title: '预订详情',
    success: '预订成功',
    name: '姓名',
    phone: '电话号码',
    mealTime: '就餐时间',
    mealNum: '就餐人数',
    people: '人'
  },
  ContactUs: {
    contact: '联系销售人员',
    info: '销售人员资讯',
    area: '地区',
    name: '姓名',
    phone: '电话',
    hongkong: '香港',
    taiwan: '台湾',
    zhuhai: '广东珠海',
    shanwei: '广东汕尾',
    shenzhen: '广东深圳',
    shantou: '广东汕头',
    dongguan: '广东东莞',
    guilin: '广西桂林',
    fuzhou: '福建福州',
    lin: '林先生',
    tian: '佃先生',
    chen: '陈先生',
    chan: '陈先生',
    qiu: '邱先生',
    liu: '刘先生',
    wang: '王先生',
    shi: '施先生',
    misschen: '陈小姐'
  },
  PlaceOrderDetail: {
    floor: '楼层',
    tableNum: '桌号',
    outTime: '订单超时',
    cooked: '菜已做完',
    overCook: '菜已上完',
    pay: '已支付',
    unpaied: '未支付',
    cancel: '已取消',
    time: '下单时间',
    oorderNum: '订单编号',
    number: '入座人数',
    status0: '准备中',
    status1: '制作中',
    status2: '制作完',
    status3: '已上菜',
    status4: '已送达',
    status5: '已退菜',
    payMethod: '支付方式',
    cash: "现金",
    wechat: '微信',
    alipay: '支付宝',
    applePay: "Apple Pay",
    creditcard: "信用卡",
    orther: '其他',
    payMoney: '付款',
    clean: '清理桌面',
    message: '订单还未结账，不能清理.',
    print: '打印',
    orderDetail: '订单详情',
    orderList: '订单列表',

    isServiceCharge: '是否开启服务费',
    isDiscountFee: '是否开启折扣费',
    discountCharge: '折扣费',

    turnTable: '转桌',
    isTurnTable: '确定要转桌？',
    turnTableErr: '该桌已有人，不能转',
    confirmPay: '确认已支付',
  },
  ForgetPassword: {
    title: "忘记密码",
    areaName: "区号选择",
    inputPhone: "请输入手机号",
    SMS: 'SMS认证',
    inputSMS: "输入验证码",
    setNewPassword: "设置新密码",
    certainPassword: "确认新密码",
    PleaseEnterThePassword: "请输入密码",
    submit: '提交',
    confirm: '确认',
    inputAreaNameAndPhone: '请输入区号和手机号码！',
    getSMSkey: '请先获取验证码',
    toast: '请填写完整信息',
    message: '数据错误',
    repasswordJudge: '密码不一致'
  },
  member: {
    AvailableBalance: "可用余额",
    Logout: "退出登录",
    Login: "登录",
    Register: "注册",
    MemberLogin: "会员登录",
    MemberRecharge: "会员充值",
    MemberRegistration: "会员注册",
    memberInfo: '会员信息',
    RechargeAmount: '充值金额',
    RechargeAmountPay: '充值金额支付',
    BalancePay: '余额支付',
    Pay: '支付',
    ChoosePaymentMethod: "请选择支付方式",
    CurrentBalance: "当前余额",
    BalanceRecharge: "余额充值",
    Balance: "余额",
    BalanceDetails: "余额明细",
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/zh.js